var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"page"},[_c('el-pagination',{attrs:{"layout":"prev, pager, next","current-page":_vm.index,"page-size":_vm.pageSize,"total":_vm.total},on:{"current-change":_vm.handleCurrentChange}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }